import { Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { usePaginateAssociates, useAssociates } from 'hooks/associates';

import AsyncTable from 'components/Tables/AsyncTable';
import StatusIndicator from 'components/StatusIndicator';
import { useFilters } from 'hooks/filters';
import { phoneFormat } from 'functions/maskFormats';
import dateFormat from 'functions/dateFormat';

const columns = [
	{
		Header: 'Nome',
		accessor: 'name'
	},
	{
		Header: 'Telefone',
		accessor: 'phone',
		Cell: ({ value }) => <Text>{phoneFormat(value)}</Text>
	},
	{
		Header: 'E-mail',
		accessor: 'email'
	},
	{
		Header: 'Data de Inscrição',
		accessor: 'created_at',
		Cell: ({ value }) => <Text>{dateFormat(value)}</Text>
	},
	{
		Header: 'Status',
		accessor: 'status',
		Cell: ({ value }) => <StatusIndicator isActive={value} size="sm" />
	}
];

const AssociatesTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		useAssociates();
	const [paginateAssociates, { loading }] = usePaginateAssociates();

	const deleteUser = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex, search }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginateAssociates({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				search: search || '',
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginateAssociates({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="associados"
			removeAction={deleteUser}
			noEdit
			noDelete
			linkRow
		/>
	);
};

export default AssociatesTable;
